<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg9">
    <div class="container">
        <div class="inner-title">
            <h3>Services Details</h3>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><i class='bx bxs-chevrons-right'></i></li>
                <li>Services Details</li>
            </ul>
        </div>
    </div>
</div>

<div class="service-dtls pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="service-dtls-slider owl-carousel owl-theme">
                    <div class="service-dtls-item">
                        <img src="assets/img/service/dtls1.jpg" alt="Images">
                    </div>

                    <div class="service-dtls-item">
                        <img src="assets/img/service/dtls2.jpg" alt="Images">
                    </div>
                </div>

                <div class="service-dtls-title">
                    <h3>Beautiful Mug Design</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tempus augue eu diam hendrerit porta quis at lorem. Morbi volutpat tortor vitae vestibulum tristique. Suspendisse nec risus dictum, feugiat mi eget, rhoncus ipsum. Quisque posuere purus ex. Praesent eget dolor tempus, vulputate ipsum sed, laoreet ante.</p>
                    <p>Phasellus rhoncus erat tempus neque molestie, sit amet mollis libero eleifend. Mauris ac justo pulvinar, ultricies elit a, tempor orci. Integer egestas nulla ac finibus hendrerit. Integer molestie elit ac lacus hendrerit, ut posuere nisi cursus. In hac habitasse platea dictumst. Nam rhoncus nisl lorem, vel semper nunc fringilla non. Maecenas aliquam molestie enim, sed suscipit dui suscipit at. Vivamus nunc elit, porttitor et risus eu, dignissim iaculis ante.Suspendisse a tellus vitae lorem tristique finibus. Suspendisse non leo non maurisposuere tempor non vitae risus. Cras non feugiat odio.</p>
                    <p>Praesent auctor aliquet neque non maximus.Cras a aliquet sapien. Praesent luctus libero et ultrices pharetra. Donec at mattis diam. Interdum et malesuada fames ac ante ipsum primis in faucibus.Curabitur urna velit, luctus ac ligulasit amet, eleifend faucibus libero.</p>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="service-sidebar">
                    <div class="service-sidebar-widget">
                        <h3>More Services</h3>
                        <ul>
                            <li>
                                <i class='bx bxs-chevrons-right'></i>
                                <a href="#">Book Cover Design</a>
                            </li>
                            <li>
                                <i class='bx bxs-chevrons-right'></i>
                                <a href="#">Pattern Design</a>
                            </li>
                            <li>
                                <i class='bx bxs-chevrons-right'></i>
                                <a href="#">Package Design</a>
                            </li>
                            <li>
                                <i class='bx bxs-chevrons-right'></i>
                                <a href="#">Brand Identy</a>
                            </li>
                            <li>
                                <i class='bx bxs-chevrons-right'></i>
                                <a href="#">T-shirt Design</a>
                            </li>
                            <li>
                                <i class='bx bxs-chevrons-right'></i>
                                <a href="#">Cover Van Design</a>
                            </li>
                        </ul>
                    </div>

                    <div class="service-sidebar-widget">
                        <h3>Contact Us</h3>
                        
                        <ul>
                            <li>
                                <i class='bx bxs-map'></i>
                                28/A Street, New York City, USA
                            </li>
                            <li>
                                <i class='bx bxs-phone-call'></i>
                                <a href="tel:+19876543210">
                                    +1 987 6543 210
                                </a> 
                            </li>
                            <li>
                                <i class='bx bxl-telegram'></i>
                                <a href="mailto:hello&#64;dizo.com">hello&#64;dizo.com</a>
                            </li>
                        </ul>
                    </div>

                    <div class="service-sidebar-tag">
                        <h3>Tags</h3>

                        <ul>
                            <li><a routerLink="/">T-shirt</a></li>
                            <li><a routerLink="/">Cover</a></li>
                            <li><a routerLink="/">Great</a></li>
                            <li><a routerLink="/">Print Media</a></li>
                            <li><a routerLink="/">Hoodie Design</a></li>
                            <li><a routerLink="/">Design</a></li>
                            <li><a routerLink="/">Mug Design</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>